/*
 * Copyright (C) 2019-2021 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Overlay useful for debugging map data.
 *
 * @remarks
 *
 * @packageDocumentation
 */

export * from "./lib/DebugTileDataSource";
